import React from 'react';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import PersonIcon from '@material-ui/icons/Person';
import EventIcon from '@material-ui/icons/Event';
import LinkIcon from '@material-ui/icons/Link';
import OnlinePriceIcon from '@material-ui/icons/MonetizationOn';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import convertIsoDatetimeToDate from '../functions/convertIsoDatetimeToDate';

const placeholders = [
  {
    field : 'register_number',
    placeholder_text : 'AAA-555',
    button_text : 'insert-register-num',
    icon: (<DirectionsCarIcon />)
  },
  {
    field : 'inspection_due_date',
    placeholder_text : '04.10.2021',
    button_text : 'insert-inspection-due-date',
    icon: (<AssignmentLateIcon />),
    type: 'date'
  },
  {
    field : 'customer_name',
    placeholder_text : 'Antti Asiakas',
    button_text : 'insert-customer-name',
    icon: (<PersonIcon />)
  },
  {
    field : 'campaign_code',
    placeholder_text : 'KOODI-123',
    button_text : 'insert-campaign-code',
    campaign_accessor : 'code',
    icon: (<LocalOfferIcon />)
  },
  {
    field : 'campaign_end_date',
    placeholder_text : '31.12.2021',
    button_text : 'insert-campaign-end-date',
    icon: (<EventIcon />),
    type: 'date'
  },
  {
    field : 'campaign_price',
    placeholder_text : '50€',
    button_text : 'insert-campaign-price',
    icon: (<AttachMoneyIcon />),
    type: 'euro'
  },
  {
    field : 'campaign_online_price',
    placeholder_text : '40€',
    button_text : 'insert-campaign-online-price',
    icon: (<OnlinePriceIcon />),
    type: 'euro'
  },
  {
    field : 'reservation_link',
    placeholder_text : 'https://www.example.com',
    placeholder_text_email : 'https://www.example.com/email',
    placeholder_text_sms : 'https://www.example.com/sms',
    button_text : 'insert-reservation-link',
    icon: (<LinkIcon />),
    isLink : true
  }
];

const replacePlaceholderField = (text, campaign, msgType, outputType) => {

  let linkText = text.replace(/{reservation_link:([^}]*)}/, '$1');

  if (linkText !== text) {
    text = '{reservation_link}';
  } else {
    linkText = null;
  }

  for(let i = 0; i < placeholders.length; i ++) {
    const placeholder = placeholders[i];
    const fieldTag = `{${placeholder.field}}`

    if(text === fieldTag) {
      let placeholderText;
      if(campaign && placeholder.campaign_accessor) {
        placeholderText = campaign[placeholder.campaign_accessor];

        switch(placeholder.type) {
        case 'date':
          placeholderText = convertIsoDatetimeToDate(placeholderText);
          break;
        case 'euro':
          placeholderText = placeholderText + ' €';
          break;
        default:
          break;
        }

      } else {
        placeholderText = (msgType ? placeholder['placeholder_text_' + msgType] : null) ?? placeholder.placeholder_text;
      }

      if(placeholder.isLink) {
        if (outputType === 'text') {
          return placeholderText;
        } else if (outputType === 'html') {
          return `<a target="_blank" rel="noopener noreferrer" href=${placeholderText}>${linkText ?? placeholderText}</a>`;
        } else {
          return <a target="_blank" rel="noopener noreferrer" href={placeholderText}>{linkText ?? placeholderText}</a>;
        }
      }

      if (outputType === 'text') {
        return placeholderText;
      } else if (outputType === 'html') {
        return `<b>${placeholderText}</b>`;
      } else {
        return <b>{placeholderText}</b>;
      }
    }
  }

  return text;
};

const replacePlaceholderFields = (text, campaign, msgType, outputType = null) => {
  let previewText = text;
  if(text == null) return '';

  const pattern = placeholders.map(placeholder => `{${placeholder.field}}`).join('|')
  const regex = new RegExp(pattern + '|{reservation_link:[^}]*}', 'g');

  let placeholderArray = previewText.match(regex);
  if(placeholderArray == null) {
    //If there aren't any placeholder fields in the text, just return the original previewText
    return previewText;
  }

  let textArray = previewText.split(regex);

  let allTextArray = [];

  for(let i = 0; i < textArray.length; i++) {
    allTextArray.push(textArray[i]);
    if(placeholderArray.length > i) allTextArray.push(placeholderArray[i]);
  }
  return allTextArray.map((text, i) => {
    const field = replacePlaceholderField(text, campaign, msgType, outputType);

    return outputType === 'html' || outputType === 'text' ? field : <span key={i}>{field}</span>;
  });
};


export { placeholders, replacePlaceholderFields };